import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "./Logo";
import { COMPANY } from "@/lib/constants";

const LINKS = [
  { to: "/uslugi", label: "Usługi", id: "nav-uslugi" },
  { to: "/realizacje", label: "Realizacje", id: "nav-realizacje" },
  { to: "/o-nas", label: "O nas", id: "nav-o-nas" },
  { to: "/blog", label: "Blog", id: "nav-blog" },
  { to: "/kontakt", label: "Kontakt", id: "nav-kontakt" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled || open ? "glass" : "bg-transparent"}`}>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8">
        <Link to="/" data-testid="nav-logo" aria-label="AD Brikman — strona główna">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              className={({ isActive }) =>
                `font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${isActive ? "text-amber" : "text-stonemute hover:text-pearl"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a href={`tel:${COMPANY.phoneRaw}`} data-testid="nav-phone" className="btn-ghost px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em]">
            {COMPANY.phone}
          </a>
          <Link to="/kontakt" data-testid="nav-cta" className="btn-amber px-5 py-2 font-mono text-[11px] font-medium uppercase tracking-[0.2em]">
            Darmowa wycena
          </Link>
        </nav>

        <button
          className="flex h-10 w-10 items-center justify-center border border-white/10 lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          <div className="space-y-1.5">
            <span className={`block h-0.5 w-5 bg-pearl transition-transform duration-300 ${open ? "translate-y-2 rotate-45" : ""}`} />
            <span className={`block h-0.5 w-5 bg-amber transition-opacity duration-300 ${open ? "opacity-0" : ""}`} />
            <span className={`block h-0.5 w-5 bg-pearl transition-transform duration-300 ${open ? "-translate-y-2 -rotate-45" : ""}`} />
          </div>
        </button>
      </div>

      {open && (
        <nav className="glass flex flex-col gap-1 px-4 pb-6 pt-2 lg:hidden">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.id}-mobile`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `font-display border-b border-white/5 py-3 text-2xl font-bold uppercase ${isActive ? "text-amber" : "text-pearl"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a href={`tel:${COMPANY.phoneRaw}`} data-testid="nav-phone-mobile" className="btn-amber mt-4 px-5 py-3 text-center font-mono text-xs uppercase tracking-[0.2em]">
            Zadzwoń: {COMPANY.phone}
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
